
/**
 * JavaScript React Framework
 */
import React from 'react';

/**
 * JavaScript React-Router
 */
import { Switch, Route } from 'react-router-dom'

/**
 * JavaScript React-Helmet (document head management)
 */
import { Helmet } from "react-helmet";

/**
 * Cascading StyleSheets
 */
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/App.css';

/**
 * Internal Application Components 
 */
import AppNavBar from './cba/appspec/header/Nav_AppNavBar.js';

/**
 * Application Routes - Content Components
 */
import Home        from './cba/appspec/body/Home.js';
import Album       from './cba/appspec/body/Album.js';
import KarnaRam    from './cba/appspec/body/KarnaRam.js';
import ITBuildOut  from './cba/appspec/body/ITBuildOut.js';
import Informatics from './cba/appspec/body/Informatics.js';
import LMS         from './cba/appspec/body/LMS.js';
import Simulators  from './cba/appspec/body/Simulators.js';

/**
 * Note: Your components tell React what you want to render
 */
class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = { page: 'Home' };
	}

	RenderChild(props) {

		window.location.hash = window.decodeURIComponent(window.location.hash);
		const hashparts = window.location.hash.split('#');
		
		if(hashparts.length > 1)
		{	
			const pageparts = window.location.hash.split('=');
			console.log(pageparts);

			if(pageparts.length > 1)
			{
				/* format: /index.html#page=Album */
				props.match.params.page = pageparts[1];

				console.log(props.match.params);

				this.setState.page = props.match.params.page;
				props.match.path = "/index.html/" + props.match.params.page;

				if(props.match.params.page === 'Album')
				{
					return <Album />;
				}
				else if(props.match.params.page === 'KarnaRam')
				{
					return <KarnaRam />;
				}
				else if(props.match.params.page === 'ITBuildOut')
				{
					return <ITBuildOut />;
				}
				else if(props.match.params.page === 'Informatics')
				{
					return <Informatics />;
				}
				else if(props.match.params.page === 'LMS')
				{
					return <LMS />;
				}
				else if(props.match.params.page === 'Engineering')
				{
					return <Simulators />;
				}
			}
		}

		return <Home />;
	}

	render() {
		return (
			<html>
				<Helmet>
        	<meta http-equiv="X-UA-Compatible" content="IE=edge" />
        	<meta charset="utf-8" />
  				<meta name="viewport" content="width=device-width, initial-scale=1" />
  				<meta name="description" content="Clayfoot: Portfolio Website for Tracy Steven Brown" />
  				<meta name="author" content="Tracy Steven Brown" />

  				{ /* Open Graph Media Container */}
  				<meta property="og:title" content="Tracy Steven Brown - Portfolio" />
			  	<meta property="og:description" content="Innovator and inventor: Tracy is an ethical, performance-focused inventor’s executive with a proven track record, a senior highly adaptive technical skillset, and the grit necessary to push through extensively challenging conditions." />
			  	<meta property="og:url" content="http://www.clayfoot.com/" />
			  	<meta property="og:image" content="http://www.clayfoot.com/static/media/tracy_06.dc7d9150.jpg" />

			  	{ /* Page Title */ }
	        <title>Tracy Steven Brown</title>
			  </Helmet>
        <body>
        	<div id="app" className="container">
						<AppNavBar />
            <div id="content">
                <Switch>
                	{ /* Homepage */ }
									<Route exact path="/" component={Home} />

									{ /* Fallback to Homepage */ }
									<Route path="/index.html" component={this.RenderChild.bind(this)} />
								</Switch>
            </div>

            <footer>
		          <p>&copy; 2017 Tracy Steven Brown &middot;</p>
		        </footer>
		      </div>
        </body>
      </html>
		); // return
	} // render
} // class


/** Template:

class MyClass extends React.Component {

	render() {
		return (
			//
			// Code Here
			//
		); // return
	} // render
} // class
*/

export default App;



// WEBPACK FOOTER //
// ./src/App.js